import { useState } from 'react';
import { Control, FieldValues, Path, useController } from 'react-hook-form';

import { ActivityDuration } from '../../../../../../db/types';
import { unix } from '../../../../../../utils/datetime';
import { useClassContext } from '../../../../../class/Context';
import { usePollContext } from '../../../../Context';

export interface Props<T extends FieldValues> {
  control: Control<T, object>;
  name: Path<T>;
}

const useDurationCellVM = <T extends FieldValues>({ control, name }: Props<T>) => {
  const { cls } = useClassContext();
  const { poll } = usePollContext();

  const durations = [
    ActivityDuration.AFTER_30_SECONDS,
    ActivityDuration.AFTER_1_MINUTE,
    ActivityDuration.AFTER_2_MINUTES,
    ActivityDuration.AFTER_5_MINUTES,
    ActivityDuration.AFTER_10_MINUTES,
    ActivityDuration.AFTER_15_MINUTES,
    ActivityDuration.AFTER_20_MINUTES,
    ActivityDuration.AFTER_30_MINUTES,
    ActivityDuration.AFTER_45_MINUTES,
    ActivityDuration.AFTER_1_HOUR,
  ].filter((duration) => cls?.endTime && unix() + duration * 60 < cls?.endTime);

  const controllerMethods = useController({ control, name });

  const [isDurationDialogOpen, setIsDurationDialogOpen] = useState(false);

  const onCellClick = () => {
    setIsDurationDialogOpen(true);
  };

  const onCloseDurationDialog = () => {
    setIsDurationDialogOpen(false);
  };

  return {
    poll,
    durations,
    controllerMethods,
    isDurationDialogOpen,
    onCellClick,
    onCloseDurationDialog,
  };
};

export default useDurationCellVM;
